import {useTranslation} from 'react-i18next';
import * as css from './TransactionPayment.css';
import {TEticketOrder} from '../../../../redux/eTicket/eTicket.type';
import {getDate, toUnixSec} from '../../../../library/dates';

interface TransactionPaymentProps {
    order: TEticketOrder;
}

function TransactionPayment({order}: TransactionPaymentProps) {
    const {t} = useTranslation('eTicket');
    const purchaseDate = order.created ? getDate(toUnixSec(order.created)) : null;
    return (
        <css.block data-cy="transaction-payment">
            <css.blockHeading>{t('paymentDetails')}</css.blockHeading>
            <css.kvList>
                {order.payMethod && (
                    <css.kvRow>
                        <css.kvLabel>{t('payMethod')}</css.kvLabel>
                        <css.kvValue>{t(`payMethods.${order.payMethod}`, {defaultValue: order.payMethod})}</css.kvValue>
                    </css.kvRow>
                )}
                {purchaseDate && (
                    <css.kvRow>
                        <css.kvLabel>{t('purchaseDate')}</css.kvLabel>
                        <css.kvValue dir="ltr">{purchaseDate}</css.kvValue>
                    </css.kvRow>
                )}
            </css.kvList>
        </css.block>
    );
}

export default TransactionPayment;
